"use client";
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@/components/ui/button';
import { contactFormSchema, type ContactFormValues } from '@/lib/validation';

export function ContactForm() {
  const [submitted, setSubmitted] = React.useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<ContactFormValues>({ resolver: zodResolver(contactFormSchema) });

  async function onSubmit(values: ContactFormValues) {
    // In production, send to an API or external service
    console.log('Contact form submission', values);
    setSubmitted(true);
    reset();
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium">Name</label>
          <input className="mt-1 w-full rounded-md border border-gray-300 p-2" {...register('name')} />
          {errors.name && <p className="mt-1 text-xs text-red-600">{errors.name.message}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium">Email</label>
          <input className="mt-1 w-full rounded-md border border-gray-300 p-2" {...register('email')} />
          {errors.email && <p className="mt-1 text-xs text-red-600">{errors.email.message}</p>}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium">Phone</label>
          <input className="mt-1 w-full rounded-md border border-gray-300 p-2" {...register('phone')} />
          {errors.phone && <p className="mt-1 text-xs text-red-600">{errors.phone.message}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium">Service Type</label>
          <select className="mt-1 w-full rounded-md border border-gray-300 p-2" {...register('serviceType')}>
            <option value="">Select a service</option>
            <option value="Stucco Repair">Stucco Repair</option>
            <option value="Plaster Installation">Plaster Installation</option>
            <option value="Lath Work">Lath Work</option>
            <option value="Texture Matching">Texture Matching</option>
            <option value="Drywall Repair">Drywall Repair</option>
            <option value="Drywall Installation">Drywall Installation</option>
          </select>
          {errors.serviceType && (
            <p className="mt-1 text-xs text-red-600">{errors.serviceType.message as string}</p>
          )}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium">Message</label>
        <textarea
          className="mt-1 w-full rounded-md border border-gray-300 p-2"
          rows={5}
          {...register('message')}
        />
        {errors.message && <p className="mt-1 text-xs text-red-600">{errors.message.message}</p>}
      </div>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Submitting…' : 'Send Message'}
      </Button>
      {submitted && (
        <p className="text-sm text-[color:var(--color-primary)] mt-2">Thanks! We’ll be in touch shortly.</p>
      )}
    </form>
  );
}
